import { createClient } from "@/utils/supabase/client";
import { useEffect, useState } from "react";

export function getUser() {
  const [user, setUser] = useState<unknown>(null); // Start with null indicating no user data
  const [loading, setLoading] = useState(true);
  const supabase = createClient();

  useEffect(() => {
    const checkUser = async () => {
      try {
        // Await the user directly since getUser() returns a promise
        const { data: user, error } = await supabase.auth.getUser();
        if (error) throw error;
        setUser(user);
      } catch (error) {
        console.error("Error fetching user:", (error as Error).message);
        setUser(null); // Consider setting to null if there's an error
      }
      setLoading(false);
    };

    checkUser();

    const { data: listener } = supabase.auth.onAuthStateChange(
      (_event, session) => {
        if (session) {
          setUser(session.user);
        } else {
          setUser(null);
        }
      },
    );

    // Proper cleanup of the listener
    return () => {
      listener.subscription.unsubscribe();
    };
  }, []); // Removed supabase from dependencies to avoid re-runs when it's not necessary

  return { user, loading };
}
